module.exports = __webpack_public_path__ + "static/media/fi.d7639bf3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/countriesFlags/fi.svg
// module id = 1445
// module chunks = 0